<template>
    <!-- <div class="container-fluid"> -->
    <div>

        <div class="title-area">
            <b-row>
                <b-col>
                    <br><br><br>
                    <!-- <div style="text-align: left; float: left;">
                        <img
                            src="@/assets/images/beta-angle-ribbon.png"
                            width=70px
                            class="mt-2;"
                        />     
                    </div> -->
                    <div style="text-align: center">
                        <img
                            :src="imgPath"
                            class="mr-2"
                            :width="logoWidth"
                        />
                        <h2>{{ title }}</h2>
                    </div>
                </b-col>
            </b-row>
            <!-- <center>
                <br><br><br>
                <img
                src="@/assets/images/beta-angle-ribbon.png"
                width=70px
                class="mt-2; float: left;"
            />
                <img
                    :src="imgPath"
                    class="mr-2"
                    :width="logoWidth"
                />
                <h2>{{ title }}</h2>
            </center> -->
        </div>
        <ExplorerInstructions />
    </div>
</template>
<script>
import ExplorerInstructions from "@/components/instructions/ExplorerInstructions.vue";
export default {
    name: "explorer-title-area",
    mixins: [],
    components: {ExplorerInstructions,},
    props: {
        title: String,
        mobile: Boolean,
        img: String,
    },
    data(){
        return{
            logoWidth: "45px",
        };
    },
    watch: {
    },
    computed: {
        imgPath () {
            var images = require.context('@/assets/images/logos/', false)
            return images('./' + this.img)
        },
    },
    methods: {
        getLogoWidth() {
            if (this.mobile) {
                this.logoWidth = "25px";
            }
            else {
                this.logoWidth = "45px";
            }
        },
    },
    mounted(){
        this.getLogoWidth();
    },
};
</script>
<style>
    .title-area h2, h5 {
        display: inline;
        vertical-align:middle
    }
</style>
